<template>
	<div class="editNote">
		<textarea
			ref="textAreaElement"
			v-model="model"
			:placeholder="t('eventNotes.typeNote')"
			:maxlength="MAX_EVENT_NOTE_LENGTH"
			class="bordered font-paragraph-s w-full rounded-sm bg-level-00 px-04 py-03 text-ink-60"
			rows="2"
			@keydown.stop
		></textarea>

		<div class="actions flex justify-end">
			<Telemetry :name="`Cancel ${mode}ed event note`">
				<Button variant="tertiary" size="s" @click="emit('cancel')">{{ t('eventNotes.cancel') }}</Button>
			</Telemetry>

			<Telemetry :name="`Save ${mode}ed event note`">
				<Button variant="tertiary" size="s" :disabled="!model" @click="emit('save', model)">{{ t('eventNotes.save') }}</Button>
			</Telemetry>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Button, useTranslation } from '@bluebrick/saas-ui'
import { ref, watch } from 'vue'
import Telemetry from '@/common/components/Telemetry.vue'
import { MAX_EVENT_NOTE_LENGTH } from '@/features/config/types'

const model = defineModel({ required: true, type: String })

const emit = defineEmits<{
	cancel: [void]
	save: [value: string]
}>()

withDefaults(
	defineProps<{
		mode?: 'add' | 'edit'
	}>(),
	{
		mode: 'add'
	}
)

const { t } = useTranslation()

const textAreaElement = ref<HTMLTextAreaElement>()

watch(textAreaElement, (element, previousElement) => {
	if (element && !previousElement) {
		// If textarea was just shown then set focus within
		textAreaElement.value?.focus()
	}
})
</script>

<style lang="scss" scoped>
.editNote {
	.bordered {
		border: var(--border-disabled);
	}
}
</style>
